import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Logo from 'components/Logo';
import ThemeToggle from 'components/ThemeToggle';

const messages = defineMessages({
  YOU_HAVE_A_MESSAGE: {
    id: 'RequestPasswordResetSuccess.YOU_HAVE_A_MESSAGE',
    defaultMessage: 'Sie haben Post',
  },
  SENDED_LINK: {
    id: 'RequestPasswordResetSuccess.SENDED_LINK',
    defaultMessage: 'Wir haben Ihnen eine Nachricht mit einem Link zugesendet.',
  },
  FOLLOW_LINK: {
    id: 'RequestPasswordResetSuccess.FOLLOW_LINK',
    defaultMessage: 'Bitte folgen Sie diesem Link um Ihr Passwort zurückzusetzen.',
  },
  BACK: {
    id: 'RequestPasswordResetSuccess.BACK',
    defaultMessage: 'Zurück zum Login',
  },
});

class RequestPasswordResetSuccess extends React.PureComponent {
    render() {
      const { intl: { formatMessage } } = this.props;

        return (
            <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: 'var(--bg-color)' }}>
                <div className="anonymous-card-wrapper" style={{ width: '100%', maxWidth: '480px' }}>
                    <div className="anonymous-card" style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                        {/* Logo Header */}
                        <div className="anonymous-header" style={{ position: 'relative', padding: '32px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Logo large />
                            <div className="anonymous-theme-toggle">
                                <ThemeToggle />
                            </div>
                        </div>

                        {/* Content */}
                        <div style={{ padding: '40px 48px', textAlign: 'center' }}>
                            {/* Success Icon */}
                            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(16, 185, 129, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                                <i className="fa fa-envelope" style={{ fontSize: '28px', color: '#10b981' }} aria-hidden="true" />
                            </div>

                            <h1 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                                {formatMessage(messages.YOU_HAVE_A_MESSAGE)}
                            </h1>
                            <p style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
                                {formatMessage(messages.SENDED_LINK)}<br /><br />
                                {formatMessage(messages.FOLLOW_LINK)}
                            </p>
                            <Link
                                to="/"
                                style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                                onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}
                            >
                                <i className="fa fa-arrow-left" aria-hidden="true" /> {formatMessage(messages.BACK)}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(RequestPasswordResetSuccess);
